<div class="overview">
  <div class="overview_content">
    @for (data of top_threat_data; track data.name; let i = $index) {
      <div class="card">
        <div class="content">
          <div class="front" [ngClass]="{'dark-mode': isDarkTheme}">
            <div class="card-title">{{data.friendly}}</div>
            <div class="card-number" [style.color]="threatColors[data.name]">{{data.count | number}}</div>
            <div class="card-subtitle">recorded</div>
          </div>
          <div class="back" [ngClass]="{'dark-mode': isDarkTheme}">
            <div class="description-text">{{ getDescription(data.name) }}</div>
          </div>
        </div>
      </div>
    }
  </div>
</div>
